import React from 'react';
import { CalendarClock, Send, Pencil, XCircle, MessageCircle, Mail, AlertTriangle, CheckCircle } from 'lucide-react';
import { fmtWhen } from './SchedulePicker';

export const ScheduledList = ({ items, onEdit, onSendNow, onCancel, busyId }) => {
  const pending = items.filter((i) => i.status === 'scheduled');
  const done = items.filter((i) => i.status !== 'scheduled');
  const Row = ({ i }) => (
    <div className={`flex items-center gap-3 bg-white border rounded-xl px-3 py-2 ${i.status === 'failed' ? 'border-red-200' : i.status === 'sent' ? 'opacity-70' : 'hover:border-amber-300'}`} data-testid={`scheduled-row-${i.id}`}>
      <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${i.kind === 'chat_reply' ? 'bg-teal-50 text-teal-700' : 'bg-amber-50 text-amber-700'}`}>{i.kind === 'chat_reply' ? <MessageCircle className="w-4 h-4" /> : <Mail className="w-4 h-4" />}</span>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-medium text-neutral-900 truncate">{i.subject || '(no subject)'} <span className="text-neutral-400 font-normal">· {i.to?.join(', ')}</span></p>
        <p className="text-[11px] text-neutral-500 truncate">{i.preview || 'Empty message'}</p>
      </div>
      <span className={`text-[11px] inline-flex items-center gap-1 shrink-0 ${i.status === 'failed' ? 'text-red-600' : i.status === 'sent' ? 'text-emerald-600' : 'text-neutral-600'}`} data-testid={`scheduled-when-${i.id}`}>
        {i.status === 'failed' ? <AlertTriangle className="w-3 h-3" /> : i.status === 'sent' ? <CheckCircle className="w-3 h-3" /> : <CalendarClock className="w-3 h-3" />}
        {i.status === 'sent' ? `Sent ${fmtWhen(i.sent_at)}` : i.status === 'failed' ? (i.error || 'Failed') : i.status === 'cancelled' ? 'Cancelled' : fmtWhen(i.send_at)}
      </span>
      {i.status === 'scheduled' && (
        <div className="flex gap-0.5 shrink-0">
          {i.kind === 'email' && <button type="button" onClick={() => onEdit(i)} className="p-1.5 rounded hover:bg-neutral-100 text-neutral-500" title="Edit" data-testid={`scheduled-edit-${i.id}`}><Pencil className="w-3.5 h-3.5" /></button>}
          <button type="button" disabled={busyId === i.id} onClick={() => onSendNow(i)} className="p-1.5 rounded hover:bg-amber-50 text-amber-700" title="Send now" data-testid={`scheduled-send-now-${i.id}`}><Send className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={() => onCancel(i)} className="p-1.5 rounded hover:bg-red-50 text-neutral-400 hover:text-red-600" title="Cancel" data-testid={`scheduled-cancel-${i.id}`}><XCircle className="w-3.5 h-3.5" /></button>
        </div>
      )}
      {i.status === 'failed' && <button type="button" disabled={busyId === i.id} onClick={() => onSendNow(i)} className="text-[11px] text-amber-700 hover:underline shrink-0" data-testid={`scheduled-retry-${i.id}`}>Retry</button>}
    </div>
  );
  return (
    <div className="space-y-4" data-testid="scheduled-list">
      <section className="space-y-2">
        <h3 className="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Upcoming · {pending.length}</h3>
        {pending.length === 0 && <p className="text-xs text-neutral-500 border border-dashed rounded-lg p-8 text-center">Nothing scheduled. Use "Send later" in the composer to queue a follow-up.</p>}
        {pending.map((i) => <Row key={i.id} i={i} />)}
      </section>
      {done.length > 0 && (
        <section className="space-y-2">
          <h3 className="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">History · {done.length}</h3>
          {done.slice(0, 30).map((i) => <Row key={i.id} i={i} />)}
        </section>
      )}
    </div>
  );
};

export default ScheduledList;
